/**
 * Feed Administration Feature Routes
 */
import type { RouteRecordRaw } from 'vue-router';
import i18next from 'i18next';

export const feedAdministrationRoutes: RouteRecordRaw[] = [
  {
    path: '/feed-administration',
    name: 'feed-administration',
    component: () => import('./views/FeedAdministrationView.vue'),
    meta: {
      title: () => i18next.t('feedAdmin.pageTitle'),
      requiredEntitlement: 'feed.feed_administer',
      breadcrumbs: [{ label: () => i18next.t('feedAdmin.pageTitle') }],
    },
  },
];
